import styled from 'styled-components';
import { Spinner } from 'reactstrap';

export const StyledSpinner = styled(Spinner)((props) => ({
  animationDuration: '1s',
}));
